import { useEffect, useRef } from "react";

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import Icon from "@rsuite/icons/Icon";
import SVGs from "./numberSVGs";

import "./stepHeader.css";
import { isIOSVersionHigherThan26Version } from "../../../../utils/getUserAgentParser";
import { useTranslation } from "react-i18next";

const ARROW_SVG =
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 4.5L9 7.5L6 10.5" stroke="black" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>


const STEPS = [
    "Основные данные",
    "Тарифы",
    "Доп. услуги",
    "Получатель/отправитель",
    "Расчет",
    "Итого"
]

export default function StepsHeader({step, setInvoiceStep, maxStep}) {
    const { t } = useTranslation("basic");
    const isIOS26Version = isIOSVersionHigherThan26Version();
    const splideRef = useRef();

    useEffect(() => {
        if (!splideRef.current) return;

        splideRef.current.go(step, {allowSameIndex: true});
        console.log(splideRef.current);
    }, [splideRef, step, maxStep]);

    return (
        <div className={`stepsHeaderWrapper gradient_bg_header ${isIOS26Version ? 'ios26_top-safe-area' : ''}`}>
            <div className="stepHeaderHeader heading-h4">
                {t("editing_template")}
                <img id="stepsHeaderImage" src="https://s3.timeweb.com/8a6e091b-publick/template_header.png"/>
            </div>
            <Splide
                options={{
                    height: "3rem",
                    focus: "center",
                    autoWidth: true,
                    autoHeight: true,
                    arrows: false,
                    gap: "1rem",
                    index: 2
                }}
                ref={splideRef}
            >
                {STEPS.slice(0, maxStep).map((item, index) => (
                    <>
                    <SplideSlide key={index} onClick={() => setInvoiceStep(index)}>
                        <div className={step === index ? "stepHeader active" : "stepHeader"}>
                            <span className="stepNumber">{SVGs[index]}</span>
                            <span className="stepName">{item}</span>
                        </div>
                    </SplideSlide>
                    <div className="stepArrow">
                        {ARROW_SVG}
                    </div>
                    </>
                ))}
            </Splide>
        </div>
    )
}